import { useSearchParams } from '@uhg-abyss/web/tools/reactRouterTools';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { useFlags } from 'launchdarkly-react-client-sdk';
import find from 'lodash/find';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { getFeatureFlag } from '../../common/Utils/getFeatureFlag';
import { useSaveEducationalContentStatus } from '../../hooks/useEducationalContent';
import { useLagoon } from '../../hooks/useLagoon';
import { StoreKeys } from '../../hooks/useStore/state';
import { useStore } from '../../hooks/useStore/useStore';
import { guestStartModalStyles } from './GuestFirstTimeUserModal.style';
import { getBlueGreenGQLApiUrl } from './utils';

export const GuestFirstTimeUserModal = () => {
  const featureFlags = useLagoon('feature-flags')();
  const data = useLagoon('ui-messaging')();
  const { t } = useTranslation();

  const flags = useFlags();
  const [searchParams] = useSearchParams();
  const guestBGApiUrl = getBlueGreenGQLApiUrl(flags, searchParams);

  const guestStartModalTitle = find(data, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.GUEST_START_MODAL_TITLE,
  });
  const guestStartModalDescription = find(data, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.GUEST_START_MODAL_DESCRIPTION,
  });

  const setEducationalContentStore = useStore(
    StoreKeys.SET_EDUCATIONAL_CONTENT_STATUS
  );

  const educationalContentStore = useStore(
    StoreKeys.EDUCATIONAL_CONTENT_STATUS
  );

  const [, setEducationalContentStatus] = useSaveEducationalContentStatus({
    url: guestBGApiUrl,
  });

  const handleOnClose = () => {
    setEducationalContentStore({
      ...educationalContentStore,
      hasViewedGuestStartModal: true,
    });

    setEducationalContentStatus({
      variables: {
        ...educationalContentStore,
        hasViewedContent: educationalContentStore?.hasViewedContent ?? true,
        hasViewedGuestStartModal: true,
      },
    });
  };

  const guestStartModalEnabled = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.GUEST_START_MODAL_ENABLED
  );

  const showGuestStartModal =
    guestStartModalEnabled &&
    educationalContentStore &&
    !educationalContentStore?.hasViewedGuestStartModal;

  return (
    <ModalDialog
      css={guestStartModalStyles}
      data-testid="guest-start-modal"
      footer={
        <Layout.Group alignLayout="left" style={{ gap: '8px' }}>
          <Button
            data-testid="guest-get-started-button"
            onClick={handleOnClose}
          >
            {t('GUEST_FIRST_TIME_USER_MODAL.GET_STARTED_BUTTON')}
          </Button>
        </Layout.Group>
      }
      header={guestStartModalTitle?.message}
      isOpen={showGuestStartModal}
      onClose={handleOnClose}
    >
      {guestStartModalDescription?.message}
    </ModalDialog>
  );
};
